/* OVD WORLDWIDE — interactive globe (Canvas2D, zero dependencies).
   Dot-matrix continents, glowing order cities, comet arcs from the home base,
   atmosphere halo, starfield. Drag to spin, idle auto-rotate. No zoom.
   Mounts into #ovd-globe; reads data-src JSON:
     { orders, countries, cities, points:[{c,cc,n,lat,lng}] }
   and data-land (land dot matrix: [[lat,lng], ...]). */
(function () {
  if (window.__ovdGlobe) return;
  window.__ovdGlobe = true;
  var TAU = Math.PI * 2, D2R = Math.PI / 180;

  function boot() {
    var host = document.getElementById('ovd-globe');
    if (!host || host.dataset.mounted) return;
    host.dataset.mounted = '1';

    var HOME = { lat: parseFloat(host.dataset.homeLat) || 40.7128, lng: parseFloat(host.dataset.homeLng) || -74.006 };
    var VIEW = { lat: parseFloat(host.dataset.viewLat) || 22, lng: parseFloat(host.dataset.viewLng) || -55 };

    var cv = document.createElement('canvas');
    cv.className = 'ovd-globe__cv';
    host.appendChild(cv);
    var ctx = cv.getContext('2d');
    var tip = document.createElement('div');
    tip.className = 'ovd-globe__tip'; tip.hidden = true;
    host.appendChild(tip);

    var W, H, R, cx, cy, dpr, stars = [], shoots = [];
    function resize() {
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      W = host.clientWidth; H = host.clientHeight;
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
      cv.style.width = W + 'px'; cv.style.height = H + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      cx = W / 2; cy = H / 2; R = Math.min(W, H) * 0.375;
      stars = [];
      var count = Math.round(Math.min(420, (W * H) / 2600));
      for (var i = 0; i < count; i++) {
        var far = Math.random();
        stars.push({
          x: Math.random() * W, y: Math.random() * H,
          r: far < 0.72 ? Math.random() * 0.7 + 0.25 : Math.random() * 1.5 + 0.6,
          a: far < 0.72 ? Math.random() * 0.32 + 0.06 : Math.random() * 0.55 + 0.25,
          p: Math.random() * TAU,
          sp: 0.008 + Math.random() * 0.03
        });
      }
      shoots.length = 0;
    }
    resize();
    window.addEventListener('resize', resize);

    function spawnShoot() {
      var edge = Math.random();
      var sx = edge < 0.5 ? Math.random() * W : (Math.random() < 0.5 ? -40 : W + 40);
      var sy = edge < 0.5 ? (Math.random() < 0.6 ? -30 : Math.random() * H * 0.6) : Math.random() * H * 0.7;
      var ang = (Math.random() * 0.5 + 0.15) * (sx > W / 2 ? Math.PI - 0.2 : 0) + (Math.random() * 0.45 + 0.2);
      shoots.push({
        x: sx, y: sy,
        vx: Math.cos(ang) * (7 + Math.random() * 7) * (sx > W * 0.8 ? -1 : 1),
        vy: Math.sin(ang) * (4 + Math.random() * 5),
        life: 1, len: 60 + Math.random() * 110
      });
      if (shoots.length > 4) shoots.shift();
    }
    setInterval(function () { if (Math.random() < 0.55) spawnShoot(); }, 2600);
    setTimeout(spawnShoot, 1500);

    var yaw = -VIEW.lng * D2R, pitch = VIEW.lat * D2R;
    var baseYaw = yaw, basePitch = pitch, sway = 0;
    var vYaw = 0, vPitch = 0, dragging = false, lastX = 0, lastY = 0, idle = 0, t = 0;

    function vec(lat, lng) {
      var la = lat * D2R, lo = lng * D2R, c = Math.cos(la);
      return [c * Math.sin(lo), Math.sin(la), c * Math.cos(lo)];
    }
    // cached trig per frame
    var cyw = 1, syw = 0, cp = 1, sp = 0;
    function sync() { cyw = Math.cos(yaw); syw = Math.sin(yaw); cp = Math.cos(pitch); sp = Math.sin(pitch); }
    function px(v) {
      var x1 = v[0] * cyw + v[2] * syw, z1 = -v[0] * syw + v[2] * cyw;
      var y2 = v[1] * cp - z1 * sp, z2 = v[1] * sp + z1 * cp;
      return { x: cx + x1 * R, y: cy - y2 * R, z: z2 };
    }
    function pxAlt(v, alt) {
      var x1 = v[0] * cyw + v[2] * syw, z1 = -v[0] * syw + v[2] * cyw;
      var y2 = v[1] * cp - z1 * sp, z2 = v[1] * sp + z1 * cp;
      return { x: cx + x1 * R * alt, y: cy - y2 * R * alt, z: z2 };
    }

    var land = [], pts = [], maxN = 1, ready = false, homeV = vec(HOME.lat, HOME.lng);

    fetch(host.dataset.land, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (a) { land = a.map(function (p) { return vec(p[0], p[1]); }); })
      .catch(function () {});

    fetch(host.dataset.src, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        pts = (d.points || []).map(function (p) {
          return { v: vec(p.lat, p.lng), c: p.c, cc: p.cc, n: p.n, flare: 0 };
        });
        maxN = pts.length ? Math.max.apply(null, pts.map(function (p) { return p.n; })) : 1;
        pts.sort(function (a, b) { return a.n - b.n; });   // big cities drawn last
        ready = true;
        stats(d);
      }).catch(function () {});

    function stats(d) {
      var scope = document.querySelector('[data-shipmap]') || document;
      var live = host.dataset.ticker === 'on';
      var els = { orders: scope.querySelector('[data-stat="orders"]'), cities: scope.querySelector('[data-stat="cities"]'), countries: scope.querySelector('[data-stat="countries"]') };
      var lag = live ? 15 : 0;
      function roll(el, target, dur) {
        if (!el) return;
        var t0 = null;
        (function step(now) {
          if (!t0) t0 = now;
          var k = Math.min((now - t0) / dur, 1);
          el.textContent = Math.round(target * (1 - Math.pow(1 - k, 3))).toLocaleString();
          if (k < 1) requestAnimationFrame(step);
        })(performance.now());
      }
      roll(els.orders, d.orders - lag, 2200); roll(els.cities, d.cities, 1800); roll(els.countries, d.countries, 1400);
      if (live && els.orders) {
        var shown = d.orders - lag;
        var iv = setInterval(function () {
          if (shown >= d.orders) return clearInterval(iv);
          shown++; els.orders.textContent = shown.toLocaleString();
          els.orders.classList.add('is-tick');
          setTimeout(function () { els.orders.classList.remove('is-tick'); }, 700);
        }, 21000 + Math.random() * 15000);
      }
    }

    // ---- comet arcs ----
    var arcs = [];
    function slerp(a, b, k) {
      var d = Math.max(-1, Math.min(1, a[0]*b[0] + a[1]*b[1] + a[2]*b[2])), o = Math.acos(d);
      if (o < 1e-6) return a;
      var s = Math.sin(o), c1 = Math.sin((1 - k) * o) / s, c2 = Math.sin(k * o) / s;
      return [a[0]*c1 + b[0]*c2, a[1]*c1 + b[1]*c2, a[2]*c1 + b[2]*c2];
    }
    function launch() {
      if (!ready || arcs.length > 4) return;
      var p = pts[Math.floor(Math.random() * pts.length)];
      var d = Math.acos(Math.max(-1, Math.min(1, homeV[0]*p.v[0] + homeV[1]*p.v[1] + homeV[2]*p.v[2])));
      arcs.push({ to: p, t: 0, sp: 0.0065 + Math.random() * 0.0035, h: 0.10 + d * 0.11 });
    }
    setInterval(launch, 1100);

    // ---- input (drag only; no zoom) ----
    function down(e) { dragging = true; idle = 0; var q = e.touches ? e.touches[0] : e; lastX = q.clientX; lastY = q.clientY; vYaw = vPitch = 0; }
    function move(e) {
      var q = e.touches ? e.touches[0] : e;
      if (!dragging) { hover(q); return; }
      idle = 0;
      var dx = q.clientX - lastX, dy = q.clientY - lastY;
      lastX = q.clientX; lastY = q.clientY;
      vYaw = dx * 0.005; vPitch = -dy * 0.004;
      yaw += vYaw; pitch = Math.max(-1.15, Math.min(1.15, pitch + vPitch));
      if (e.touches && e.cancelable) e.preventDefault();
    }
    function up() { dragging = false; }
    host.addEventListener('mousedown', down);
    host.addEventListener('touchstart', down, { passive: true });
    window.addEventListener('mousemove', move);
    host.addEventListener('touchmove', move, { passive: false });
    window.addEventListener('mouseup', up);
    window.addEventListener('touchend', up);
    host.addEventListener('mouseleave', function () { tip.hidden = true; hoverPt = null; });

    var hoverPt = null;
    function hover(q) {
      if (!ready) return;
      var r = cv.getBoundingClientRect(), mx = q.clientX - r.left, my = q.clientY - r.top;
      var best = null, bd = 256;
      for (var i = pts.length - 1; i >= 0; i--) {
        var s = px(pts[i].v);
        if (s.z <= 0) continue;
        var dx = s.x - mx, dy = s.y - my, d2 = dx * dx + dy * dy;
        if (d2 < bd) { bd = d2; best = { p: pts[i], s: s }; }
      }
      hoverPt = best ? best.p : null;
      if (best) {
        tip.hidden = false;
        tip.textContent = best.p.c + ', ' + best.p.cc;
        tip.style.left = (best.s.x + 14) + 'px';
        tip.style.top = (best.s.y - 12) + 'px';
      } else tip.hidden = true;
    }

    function frame() {
      t++;
      sync();
      ctx.clearRect(0, 0, W, H);

      // starfield
      for (var si = 0; si < stars.length; si++) {
        var st = stars[si];
        var tw = st.a * (0.55 + 0.45 * Math.sin(t * st.sp + st.p));
        ctx.fillStyle = 'rgba(255,255,255,' + tw + ')';
        if (st.r > 1.1) {
          ctx.beginPath(); ctx.arc(st.x, st.y, st.r * 0.6, 0, TAU); ctx.fill();
          ctx.globalAlpha = tw * 0.5;
          ctx.beginPath(); ctx.arc(st.x, st.y, st.r * 2.2, 0, TAU);
          ctx.fillStyle = 'rgba(255,255,255,0.10)'; ctx.fill();
          ctx.globalAlpha = 1;
        } else {
          ctx.fillRect(st.x, st.y, st.r, st.r);
        }
      }

      // shooting stars
      for (var shi = shoots.length - 1; shi >= 0; shi--) {
        var sh = shoots[shi];
        sh.x += sh.vx; sh.y += sh.vy; sh.life -= 0.011;
        if (sh.life <= 0 || sh.x < -200 || sh.x > W + 200 || sh.y > H + 120) { shoots.splice(shi, 1); continue; }
        var m2 = Math.hypot(sh.vx, sh.vy) || 1;
        var tx = sh.x - (sh.vx / m2) * sh.len, ty = sh.y - (sh.vy / m2) * sh.len;
        var grad = ctx.createLinearGradient(tx, ty, sh.x, sh.y);
        grad.addColorStop(0, 'rgba(255,255,255,0)');
        grad.addColorStop(1, 'rgba(255,255,255,' + (0.55 * sh.life) + ')');
        ctx.beginPath(); ctx.moveTo(tx, ty); ctx.lineTo(sh.x, sh.y);
        ctx.strokeStyle = grad; ctx.lineWidth = 1.4; ctx.lineCap = 'round'; ctx.stroke();
        ctx.beginPath(); ctx.arc(sh.x, sh.y, 1.5, 0, TAU);
        ctx.fillStyle = 'rgba(255,255,255,' + (0.9 * sh.life) + ')'; ctx.fill();
      }

      // atmosphere halo
      var halo = ctx.createRadialGradient(cx, cy, R * 0.96, cx, cy, R * 1.28);
      halo.addColorStop(0, 'rgba(255,255,255,0.10)');
      halo.addColorStop(0.45, 'rgba(255,255,255,0.035)');
      halo.addColorStop(1, 'rgba(255,255,255,0)');
      ctx.beginPath(); ctx.arc(cx, cy, R * 1.28, 0, TAU); ctx.fillStyle = halo; ctx.fill();

      // sphere body
      var body = ctx.createRadialGradient(cx - R * 0.35, cy - R * 0.4, R * 0.05, cx, cy, R);
      body.addColorStop(0, '#161616'); body.addColorStop(0.6, '#0a0a0a'); body.addColorStop(1, '#030303');
      ctx.beginPath(); ctx.arc(cx, cy, R, 0, TAU); ctx.fillStyle = body; ctx.fill();

      // land dot matrix
      for (var li = 0; li < land.length; li++) {
        var lv = land[li];
        var x1 = lv[0] * cyw + lv[2] * syw, z1 = -lv[0] * syw + lv[2] * cyw;
        var y2 = lv[1] * cp - z1 * sp, z2 = lv[1] * sp + z1 * cp;
        if (z2 <= 0.02) continue;
        var a = 0.10 + z2 * 0.26;
        ctx.fillStyle = 'rgba(255,255,255,' + a + ')';
        var s = 0.7 + z2 * 0.9;
        ctx.fillRect(cx + x1 * R - s / 2, cy - y2 * R - s / 2, s, s);
      }

      // rim light
      ctx.save();
      ctx.beginPath(); ctx.arc(cx, cy, R, 0, TAU);
      ctx.strokeStyle = 'rgba(255,255,255,0.22)'; ctx.lineWidth = 1;
      ctx.shadowColor = 'rgba(255,255,255,0.45)'; ctx.shadowBlur = 22; ctx.stroke();
      ctx.restore();

      // order cities
      if (ready) {
        for (var i = 0; i < pts.length; i++) {
          var p = pts[i];
          var v = p.v;
          var X1 = v[0] * cyw + v[2] * syw, Z1 = -v[0] * syw + v[2] * cyw;
          var Y2 = v[1] * cp - Z1 * sp, Z2 = v[1] * sp + Z1 * cp;
          if (Z2 <= 0.02) { if (p.flare > 0) p.flare -= 0.014; continue; }
          var sx = cx + X1 * R, sy = cy - Y2 * R;
          var depth = 0.35 + Z2 * 0.65;
          var w = Math.sqrt(p.n / maxN);
          var size = (0.9 + w * 3.4) * depth;
          var alpha = (0.5 + w * 0.45) * depth;
          if (p.flare > 0) {
            p.flare -= 0.014; if (p.flare < 0) p.flare = 0;
            var f = p.flare;
            var g2 = ctx.createRadialGradient(sx, sy, 0, sx, sy, 6 + f * 26);
            g2.addColorStop(0, 'rgba(255,255,255,' + (0.42 * f) + ')');
            g2.addColorStop(1, 'rgba(255,255,255,0)');
            ctx.beginPath(); ctx.arc(sx, sy, 6 + f * 26, 0, TAU); ctx.fillStyle = g2; ctx.fill();
            alpha = Math.min(1, alpha + f); size += f * 1.8;
          }
          if (p === hoverPt) { alpha = 1; size += 1.6; }
          ctx.beginPath(); ctx.arc(sx, sy, size, 0, TAU);
          ctx.fillStyle = 'rgba(255,255,255,' + alpha + ')'; ctx.fill();
          if (w > 0.45 || p.flare > 0) {         // halo for the heavy hitters only
            var g3 = ctx.createRadialGradient(sx, sy, 0, sx, sy, size * 4.5);
            g3.addColorStop(0, 'rgba(255,255,255,' + (0.20 * depth) + ')');
            g3.addColorStop(1, 'rgba(255,255,255,0)');
            ctx.beginPath(); ctx.arc(sx, sy, size * 4.5, 0, TAU); ctx.fillStyle = g3; ctx.fill();
          }
        }
        // home base — pulsing ring
        var hs = px(homeV);
        if (hs.z > 0) {
          var pulse = (t % 90) / 90;
          ctx.beginPath(); ctx.arc(hs.x, hs.y, 4 + pulse * 16, 0, TAU);
          ctx.strokeStyle = 'rgba(255,255,255,' + (0.35 * (1 - pulse)) + ')'; ctx.lineWidth = 1; ctx.stroke();
          ctx.save();
          ctx.beginPath(); ctx.arc(hs.x, hs.y, 3.2, 0, TAU);
          ctx.fillStyle = '#fff'; ctx.shadowColor = '#fff'; ctx.shadowBlur = 16; ctx.fill();
          ctx.restore();
        }
      }

      // comet arcs
      for (var ai = arcs.length - 1; ai >= 0; ai--) {
        var A = arcs[ai];
        A.t += A.sp;
        if (A.t >= 1.3) { A.to.flare = 1; arcs.splice(ai, 1); continue; }
        var head = Math.min(A.t, 1), tail = Math.max(0, head - 0.30);
        var prev = null, hx = 0, hy = 0, hz = -1;
        for (var k = tail; k <= head + 1e-9; k += 0.018) {
          var pv = slerp(homeV, A.to.v, k);
          var m = Math.sqrt(pv[0]*pv[0] + pv[1]*pv[1] + pv[2]*pv[2]);
          var alt = 1 + Math.sin(Math.PI * k) * A.h;
          var s2 = pxAlt([pv[0]/m, pv[1]/m, pv[2]/m], alt);
          if (s2.z <= -0.25) { prev = null; continue; }
          if (prev) {
            var seg = (k - tail) / 0.30;                       // 0 tail → 1 head
            var fade = A.t > 1 ? Math.max(0, 1 - (A.t - 1) / 0.3) : 1;
            ctx.beginPath(); ctx.moveTo(prev.x, prev.y); ctx.lineTo(s2.x, s2.y);
            ctx.strokeStyle = 'rgba(255,255,255,' + (0.75 * seg * seg * fade) + ')';
            ctx.lineWidth = 0.6 + seg * 1.5; ctx.lineCap = 'round'; ctx.stroke();
          }
          prev = s2; hx = s2.x; hy = s2.y; hz = s2.z;
        }
        if (A.t <= 1 && hz > -0.25) {
          var gh = ctx.createRadialGradient(hx, hy, 0, hx, hy, 14);
          gh.addColorStop(0, 'rgba(255,255,255,0.85)'); gh.addColorStop(1, 'rgba(255,255,255,0)');
          ctx.beginPath(); ctx.arc(hx, hy, 14, 0, TAU); ctx.fillStyle = gh; ctx.fill();
          ctx.beginPath(); ctx.arc(hx, hy, 2.4, 0, TAU); ctx.fillStyle = '#fff'; ctx.fill();
        }
      }

      if (!dragging) {
        idle++;
        yaw += vYaw; pitch = Math.max(-1.15, Math.min(1.15, pitch + vPitch));
        vYaw *= 0.95; vPitch *= 0.95;
        if (Math.abs(vYaw) < 0.0005) vYaw = 0;
        if (Math.abs(vPitch) < 0.0005) vPitch = 0;
        // After a pause, drift back to the order-dense view and sway gently
        // around it instead of spinning away into empty ocean.
        if (idle > 150 && !vYaw && !vPitch) {
          sway += 0.0022;
          var targetYaw = baseYaw + Math.sin(sway) * 0.30;      // ±17°
          var targetPitch = basePitch + Math.sin(sway * 0.6) * 0.06;
          yaw += (targetYaw - yaw) * 0.012;
          pitch += (targetPitch - pitch) * 0.012;
        }
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('ovd:rescan', boot);
  ['barba:after', 'barba:enter'].forEach(function (e) { window.addEventListener(e, function () { setTimeout(boot, 120); }); });
})();
